import axios from "@/api/axiosInstance";
import {
  GetThumbnailOffendersRequest,
  GetThumbnailOffendersResponse,
} from "./types";

export const getThumbnailOffenders = async (
  request: GetThumbnailOffendersRequest = {},
): Promise<GetThumbnailOffendersResponse> => {
  const response = await axios.get<GetThumbnailOffendersResponse>(
    "/api/private/admin/image-remediation/offenders",
    {
      params: request.entityType
        ? { entityType: request.entityType }
        : undefined,
    },
  );
  return response.data;
};
